<template>
  <v-container fluid>
    <v-tabs
      color="transparent"
      v-model="tab"
      show-arrows
    >
      <v-tabs-slider color="primary"></v-tabs-slider>
      <v-layout align-center justify-space-between>
        <span>
          <v-tab v-for="tabItem in tabs" :key="tabItem">
            {{ tabItem }}
          </v-tab>
        </span>
      </v-layout>
      <v-tabs-items v-model="tab" touchless>
        <v-tab-item>
          <v-layout v-if="!isAdmin">
            <v-flex xs3>
              <v-btn dark color="primary" @click.stop="showEditEeiDialog()"><v-icon dark>add</v-icon>{{ $t('eei') }}</v-btn>
            </v-flex>
            <v-flex><v-icon>info</v-icon> {{ $t('eeiInfo') }}</v-flex>
          </v-layout>
          <PaginationController
            v-model="eeiHistory"
            getDataActionName="getEeiPagination"
            :historyLimit="historyLimit"
            :searchBoxLabel="$t('search')"
            :searchBoxHint="$t('eeiSearchBoxHint')"
            :select="isAdmin ? (selectedBalanceTable || {}).clientKey : null"
            haveSearchBox
            haveStartDate
          >
            <template v-slot:dataTable>
              <v-data-table
                :headers="headers"
                :items="eeiHistory"
                hide-actions
                item-key="_key"
                select-all="blue"
                v-model="selectedEei"
              >
                <template v-slot:items="props">
                  <td class="checkbox-align-center" @click="props.item.url && props.item.status !== 'canceled' && (props.selected = !props.selected)">
                    <v-layout>
                      <v-checkbox
                        :disabled="!props.item.url || props.item.status === 'canceled'"
                        @click.stop="() => { props.selected = !props.selected }"
                        :value="props.selected"
                        primary
                        hide-details
                      ></v-checkbox>
                    </v-layout>
                  </td>
                  <td class="text-xs-left">
                    <v-layout>
                      <strong>ID: </strong>{{ props.item.requestId }}
                    </v-layout>
                    <v-layout wrap v-if="props.item.clientName && isAdmin">
                      <span class="font-weight-bold">{{ $t('client') }}:&nbsp; </span>{{ props.item.clientName }}
                    </v-layout>
                    <v-layout justify-space-between v-for="(commodity, index) in props.item.commodities" :key="index">
                      <v-flex xs7>
                        {{ commodity.profileName }} （{{ commodity.scheduleBCode }}）
                      </v-flex>
                      <v-flex xs3>
                        {{ commodity.quantity }}
                      </v-flex>
                    </v-layout>
                  </td>
                  <td class="text-xs-left">
                    <LabelAddressWidget
                      :address="props.item.from"/>
                  </td>
                  <td class="text-xs-left">
                    <LabelAddressWidget
                      :address="props.item.to"/>
                  </td>
                  <td class="text-xs-left">
                    {{ props.item.status === 'rejected' ? props.item.message : props.item.itn }}
                  </td>
                  <td v-if="$store.getters.activeWarehouse" class="text-xs-left">
                    {{ organizationKeyToId.get(props.item.clientKey) }}
                  </td>
                  <td class="text-xs-left">
                    <v-layout>
                      {{ toDateYYYYMMDDHHmm(props.item.createTime) }}
                    </v-layout>
                    <v-layout>
                      {{ props.item.onboardDate }}
                    </v-layout>
                  </td>
                  <td class="text-xs-left">
                    <v-layout>
                      <v-flex v-if="props.item.status === 'error'">
                        <v-tooltip top>
                          <template v-slot:activator="tooltip">
                            <div v-on="tooltip.on">
                              <span class="partial_highlight">
                                {{ props.item.status || 'pending' }}
                              </span>
                            </div>
                          </template>
                          {{ props.item.message }}
                        </v-tooltip>
                      </v-flex>
                      <v-flex v-else>
                        {{ props.item.status || 'pending' }}
                      </v-flex>
                    </v-layout>
                  </td>
                  <td :class="props.item.totalAmount ? 'text-xs-left fontRed' : (props.item.amount > 0 ? 'text-xs-left fontGreen' : 'text-xs-left fontRed')">
                    ${{ -props.item.totalAmount || props.item.amount || 0 }}
                  </td>
                  <td class="text-xs-left">
                    <v-layout>
                      <v-flex v-if="!props.item.status || props.item.status === 'pending'">
                        <v-tooltip top>
                          <template v-slot:activator="tooltip">
                            <div v-on="tooltip.on">
                              <LoaderButton
                                buttonIcon="refresh"
                                flat
                                :promiseAwait="getEeiStatus"
                                :promiseItem="props.item"
                              ></LoaderButton>
                            </div>
                          </template>
                          {{ $t('getStatus') }}
                        </v-tooltip>
                      </v-flex>
                      <v-flex v-else-if="!isAdmin">
                        <v-tooltip top>
                          <template v-slot:activator="tooltip">
                            <div v-on="tooltip.on">
                              <v-btn
                                icon
                                color="primary"
                                flat
                                @click="(e) => props.item.status === 'canceled' ? showRecreateEeiDialog(props.item) : showEditEeiDialog(props.item)"
                              >
                                <v-icon v-if="props.item.status === 'canceled'">content_copy</v-icon>
                                <v-icon v-else>edit</v-icon>
                              </v-btn>
                            </div>
                          </template>
                          {{ props.item.status === 'canceled' ? `${$t('copy')} EEI` : `${$t('update')} EEI` }}
                        </v-tooltip>
                      </v-flex>
                      <v-flex v-if="props.item.status === 'ready'">
                        <v-tooltip top>
                          <template v-slot:activator="tooltip">
                            <div v-on="tooltip.on">
                              <v-btn
                                icon
                                color="primary"
                                flat
                                @click="(e) => showCreateInternationalLabelPopup(props.item)"
                              >
                                <v-icon>shopping_cart</v-icon>
                              </v-btn>
                            </div>
                          </template>
                          {{$t('createInternationalLabel')}}
                        </v-tooltip>
                      </v-flex>
                      <v-flex v-if="!['canceled', 'pending'].includes(props.item.status)">
                        <v-tooltip top>
                          <template v-slot:activator="tooltip">
                            <div v-on="tooltip.on">
                              <LoaderButton
                                buttonIcon="delete"
                                flat
                                :promiseAwait="cancelEei"
                                :promiseItem="props.item"
                              ></LoaderButton>
                            </div>
                          </template>
                          {{ $t('cancel') }} EEI
                        </v-tooltip>
                      </v-flex>
                    </v-layout>
                  </td>
                </template>
              </v-data-table>
            </template>
            <template v-slot:beforeMenu>
              <v-layout row wrap justify-space-between v-if="isAdmin">
                <v-flex md6>
                  <v-autocomplete
                    :label="$t('selectOrg')"
                    v-model="selectedBalanceTable"
                    return-object
                    item-text="clientName"
                    :items="balances"
                    clearable></v-autocomplete>
                </v-flex>
              </v-layout>
            </template>
          </PaginationController>
        </v-tab-item>
      </v-tabs-items>
    </v-tabs>
    <EeiEditPopup
      v-model="eeiDialog"
      v-if="eeiDialog"
      :eeiInEdit="eeiInEdit"
      @submitted="onProcessEei"
      :isRecreate="isRecreate"/>
    <LabelCreateInternationalPopup
      v-if="isShowCreateInternationalLabelPopup"
      v-model="isShowCreateInternationalLabelPopup"
      :idGenerator="labelIdGenerator"
      :labelInfo='labelInfo'
      >
    </LabelCreateInternationalPopup>
  </v-container>
</template>

<script>

import PaginationController from './PaginationController'
import LoaderButton from './LoaderButton'
import FormSubmitPopup from './FormSubmitPopup'
import EeiEditPopup from './EeiEditPopup'
import { checkRules, timeTools, measurementTools, getRandomIdByTime } from '../utils/tools'
import LabelAddressWidget from './LabelAddressWidget'
import LabelCreateInternationalPopup from './LabelCreateInternationalPopup.vue'
export default {
  name: 'Eei',
  components: {
    PaginationController,
    LoaderButton,
    FormSubmitPopup,
    EeiEditPopup,
    LabelAddressWidget,
    LabelCreateInternationalPopup
  },
  mixins: [checkRules, timeTools, measurementTools],
  data () {
    return {
      tab: null,
      tabs: [
        this.$t('eei')
      ],
      rowPerPage: [15, 30, 50, {text: this.$t('all'), value: -1}],
      historyLimit: 25,
      eeiHistory: [],
      selectedEei: [],
      eeiDialog: false,
      eeiInEdit: {},
      headers: this.$store.getters.activeWarehouse ? [
        { text: this.$t('details<-->Quantity'), value: 'signature', align: 'left', sortable: false, width: '30%' },
        { text: this.$t('from'), value: 'from', align: 'left', sortable: false },
        { text: this.$t('to'), value: 'to', align: 'left', sortable: false },
        { text: 'ITN', value: 'itn', align: 'left', sortable: false, width: '10%' },
        { text: this.$t('creator'), value: 'clientKey', align: 'left', sortable: false },
        { text: `${this.$t('createTime')}/${this.$t('OnboardDate')}`, value: 'createTime', align: 'left', sortable: false },
        { text: this.$t('status'), value: 'status', align: 'left', sortable: false },
        { text: this.$t('totalAmount'), value: 'totalAmount', align: 'left', sortable: false },
        { text: this.$t('actions'), value: '', align: 'center', sortable: false, width: '5%' }
      ] : [
        { text: this.$t('details<-->Quantity'), value: 'signature', align: 'left', sortable: false, width: '30%' },
        { text: this.$t('from'), value: 'from', align: 'left', sortable: false },
        { text: this.$t('to'), value: 'to', align: 'left', sortable: false },
        { text: 'ITN', value: 'itn', align: 'left', sortable: false, width: '10%' },
        { text: `${this.$t('createTime')}/${this.$t('OnboardDate')}`, value: 'createTime', align: 'left', sortable: false },
        { text: this.$t('status'), value: 'status', align: 'left', sortable: false },
        { text: this.$t('totalAmount'), value: 'totalAmount', align: 'left', sortable: false },
        { text: this.$t('actions'), value: '', align: 'center', sortable: false, width: '5%' }
      ],
      isRecreate: false,
      isAdmin: false,
      selectedBalanceTable: {},
      isShowCreateInternationalLabelPopup: false,
      labelInfo: {}
    }
  },
  mounted () {
    if (this.isAdmin && !this.balances.length) {
      this.$store.dispatch('getAllSystemBalances')
    }
    try {
      if (!this.commodityTemplates || this.commodityTemplates.length === 0) {
        this.$store.dispatch('getCommodityTemplates')
      }
    } catch (error) {
      console.error('Failed to fetch commodity templates:', error)
    }

    try {
      if (!this.commoditiesList || this.commoditiesList.length === 0) {
        this.$store.dispatch('getCommoditiesList', {})
      }
    } catch (error) {
      console.error('Failed to fetch commodities list:', error)
    }
  },
  watch: {
    tab () {
      this.filter = ''
    }
  },
  computed: {
    env () {
      return process.env.NODE_ENV
    },
    isMeasurementMetric () {
      return !!this.$store.getters.isMeasurementMetric
    },
    balances () {
      return this.$store.getters.systemBalances
    },
    commodityTemplates () {
      return this.$store.getters.commodityTemplates || []
    },
    commoditiesList () {
      return this.$store.getters.commoditiesList || []
    }
  },
  methods: {
    labelIdGenerator (qty) {
      let idSet = new Set()
      while (idSet.size < qty) {
        idSet.add(getRandomIdByTime(3))
      }
      return [...idSet]
    },
    showEditEeiDialog (item = {}) {
      this.eeiDialog = true
      this.eeiInEdit = item
      this.isRecreate = false
    },
    showRecreateEeiDialog (item = {}) {
      this.eeiDialog = true
      this.eeiInEdit = item
      this.isRecreate = true
    },
    async getEeiStatus (item) {
      const {status, itn, message} = await this.$store.dispatch('getEeiStatus', item)
      let idx = this.eeiHistory.findIndex(eei => eei.requestId === item.requestId)
      if (idx !== -1) {
        let newItem = status === 'rejected' ? Object.assign(item, {
          message,
          status,
          createTime: this.eeiHistory[idx].createTime || null
        }) : Object.assign(item, {
          itn,
          status: status === 'success' ? 'ready' : status,
          createTime: this.eeiHistory[idx].createTime || null
        })
        this.$set(this.eeiHistory, idx, newItem)
      }
    },
    updateLabelStatus (rtnArray) {
      rtnArray.sort((a, b) => b._key < a._key ? -1 : 1)
      this.labels = [...rtnArray, ...this.labels]
    },
    async cancelEei (item) {
      if (!confirm(this.$t('confirmDelete', { name: 'EEI' }))) return 'done'
      await this.$store.dispatch('cancelEei', item)
        .catch(e => {
          console.log(e.message)
          this.$store.dispatch('showToast', {info: e.message, level: 'error'})
          throw e
        })
      this.$set(item, 'status', 'canceled')
    },
    onProcessEei (item) {
      const {res, requestId} = item
      const {status, message, itn} = res
      let index = this.eeiHistory.findIndex(eei => eei.requestId === requestId)
      if (index !== -1) {
        this.$set(this.eeiHistory, index, Object.assign(item, {
          itn: status === 'success' ? itn : message,
          status: status === 'success' ? 'ready' : status,
          createTime: this.eeiHistory[index].createTime || null
        }))
      } else {
        this.eeiHistory.unshift({
          ...item,
          createTime: new Date()
        })
      }
    },
    showCreateInternationalLabelPopup (item) {
      this.isShowCreateInternationalLabelPopup = true
      this.labelInfo = Object.assign(this.labelInfo, item)
    }
  }
}
</script>

<style scoped>
  .flash_alert{
    background-color: inherit !important;
    color: red;
    border: 0px;
  }

  .fontRed {
    color: red;
  }

  .fontGreen {
    color: green;
  }

  .partial_highlight {
    background-color: yellow;
  }
</style>



// WEBPACK FOOTER //
// src/components/Eei.vue